
import { getTransactionByIdAPI,getPortfoliosByassetTransType,getUserPageAccess } from "../../config/apiConfig";
import { sbaAxios } from "../utils/sbaAxios"

export const getTransactionByID= async (TransID)=>{
    if(TransID)
    {
        try{
            const res = await sbaAxios({url:getTransactionByIdAPI+TransID})
            return res;
        } 
        catch (e){
            console.log(e);
            throw e;
        }
    }
};
export const currencyFormatter=(value , maxDeciaml)=>{
 
    try {
        const formattedNumber = value.toLocaleString("en-US", {
            maximumFractionDigits: maxDeciaml,
            minimumFractionDigits: maxDeciaml
        });
        return formattedNumber;
    } catch (error) {
        const number=0;
        return number.toFixed(maxDeciaml);
    }
    
};
export const getPortfolioListByAssetAndTransType=async(assetID,transType)=>{
    try {
        const response=await sbaAxios({url:`${getPortfoliosByassetTransType}${transType},${assetID}`});
        return response;
    } catch (error) {
        return [];
    }

}
export const gettransactionEditAccess=async()=>{
    try {
        const response=await sbaAxios({url: `${getUserPageAccess}?keyName=TransactionEditAccess` });
        return response;
    } catch (error) {
        return [];
    }

}

export const gettransactionAddAccess=async()=>{
    try {
        const response=await sbaAxios({url: `${getUserPageAccess}?keyName=TransactionAddAccess` });
        return response;
    } catch (error) {
        return [];
    }

}